import type { ReactNode } from 'react';

export const symbol_touchpad_mouse: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M773-186.86q47-46.85 47-113.14v-70H500v70q0 66.29 46.8 113.14Q593.6-140 659.8-140T773-186.86ZM500-430h130v-147q-54 11-90 51.5T500-430Zm190 0h130q-4-55-40-95.5T690-577v147ZM504-144q-64-64-64-156v-120q0-92 64-156t156-64q92 0 156 64t64 156v120q0 92-64 156T660-80q-92 0-156-64Zm-364-16q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h710q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140v520h210q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm0-60v-520 520Z"
		/>
	</svg>
);
